import React, { useEffect } from "react"
import { Box } from "@mui/material"
import { AppModal, AskIrisButton } from "@components"
import { besidePanel } from "@components/AskIris/besidePanel"
import { currencyCode, reports, searchID, userData } from "@signals"
import { pushRight } from "@app/@signals"
import { evolutionChartVisibility, openEvolutionModal } from "Pages/AnalyzersV2/@signals"
import { evolutionEvidence } from "Pages/AnalyzersV2/@services/askEvidence"
import { analyzerAskContext, analyzerHasData } from "Pages/AnalyzersV2/@services/askScope"
import { isIrisUser } from "Layout/PmsAgentWidget"
import { isEmpty } from "@ui-seeker/utils"
import AnalyzerEvolutionChart from "Pages/AnalyzersV2/@components/EvolutionModal/Chart"
import AnalyzerEvolutionChartActions from "Pages/AnalyzersV2/@components/EvolutionModal/ChartActions"
import useEvolutionModalData from "Pages/AnalyzersV2/@components/EvolutionModal/@hooks/useData"
import AnalyzerExecutionInfo, { hasExecutionInfo } from "Pages/AnalyzersV2/@components/ExecutionInfo"


export default function AnalyzerEvolutionModal({ isRating = false }) {
	const { onSubmit, isLoading, keySeries, chartData, setIsVisible, setIsLoading, officeData, executionDateTime } = useEvolutionModalData()

	useEffect(() => {
		if (!isEmpty(openEvolutionModal.value)) onSubmit()
	}, [openEvolutionModal.value])

	// "Ask Iris" (CU-869fkdhjv phase 3, UX C3, plan § 2.5): in the header next to the legend's eye; not on Rating,
	// not on the tour's demo chart. The modal stays open beside the panel: it narrows by the drawer's width
	// (`pushRight`, as the fixed header) and lets the focus go to the panel's box (`disableEnforceFocus`).
	const opened = openEvolutionModal.value || {}
	const askable = !isRating && !opened.demoMode && analyzerHasData()
	const withIris = askable && isIrisUser(userData.value)
	const getAsk = () => {
		const ctx = analyzerAskContext()
		const pd = opened.price_data || {}
		const origin = opened.askOrigin || { from: 'column', date: pd.pickup_date, days: pd.length_of_rental }
		return evolutionEvidence({
			section: ctx.section, origin, data: chartData, series: keySeries, visible: evolutionChartVisibility.value,
			currency: currencyCode.value, params: ctx.params, freshness: ctx.freshness, dsRepricing: ctx.dsRepricing,
		})
	}


	return <AppModal
		isOpen={!isEmpty(openEvolutionModal.value)}
		controller={() => openEvolutionModal.value = {}}
		title="Evolution Chart"
		icon="chart-line"
		subtitle={!searchID.value && !!reports.value && hasExecutionInfo(officeData, executionDateTime) && <AnalyzerExecutionInfo officeData={officeData} executionDateTime={executionDateTime} fontSize={13}/>}
		headerActions={<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
			{askable && !isLoading && <AskIrisButton variant="label" tooltip="Ask Iris about this evolution" getAsk={getAsk} hasData={!!chartData?.length}/>}
			<AnalyzerEvolutionChartActions setIsVisible={setIsVisible} setIsLoading={setIsLoading}/>
		</Box>}
		containerProps={besidePanel({ fullScreen: true, sx: {
			'.MuiDialogContent-root': { px: 3, pt: 0, pb: 2 },
			'.MuiDialogContent-root .MuiCard-root': { border: 'none', boxShadow: 'none', borderRadius: 0 },
		}}, { withIris, right: pushRight.value })}
		hideActions
	>
		<AnalyzerEvolutionChart
			chartData={chartData}
			keySeries={keySeries}
			isLoading={isLoading}
			isRating={isRating}
		/>
	</AppModal>
}
